/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum CohortrendementTotNiveau {
    ONDER_NIVEAU = "Onder niveau",
    ONDER_NIVEAU_PROGNOSE = "Onder niveau (prognose)",
    OP_NIVEAU = "Op niveau",
    OP_NIVEAU_PROGNOSE = "Op niveau (prognose)",
    BOVEN_NIVEAU = "Boven niveau",
    BOVEN_NIVEAU_PROGNOSE = "Boven niveau (prognose)"
}
